export function SettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-secondary-900 dark:text-white">Paramètres</h2>
        <p className="text-sm text-secondary-500">Configurez votre espace de travail</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2 space-y-6">
          <div className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900">
            <h3 className="font-semibold text-secondary-900 dark:text-white">
              Informations du Tenant
            </h3>
            <div className="mt-4 space-y-4">
              <div>
                <label className="block text-sm font-medium text-secondary-700 dark:text-secondary-300">
                  Nom de l'organisation
                </label>
                <input
                  type="text"
                  className="mt-1 w-full rounded-lg border border-secondary-200 px-3 py-2 dark:border-secondary-700 dark:bg-secondary-800"
                  defaultValue="DevFactory"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-secondary-700 dark:text-secondary-300">
                  Domaine
                </label>
                <input
                  type="text"
                  className="mt-1 w-full rounded-lg border border-secondary-200 px-3 py-2 dark:border-secondary-700 dark:bg-secondary-800"
                  defaultValue="devfactory.studio"
                />
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900">
            <h3 className="font-semibold text-secondary-900 dark:text-white">Intégrations</h3>
            <div className="mt-4 space-y-3">
              {[
                { name: 'Anthropic (Claude)', status: 'connected' },
                { name: 'Cloudflare', status: 'connected' },
                { name: 'Neon Database', status: 'connected' },
                { name: 'Email (SMTP)', status: 'not_connected' },
              ].map((integration) => (
                <div
                  key={integration.name}
                  className="flex items-center justify-between rounded-lg border border-secondary-200 p-4 dark:border-secondary-700"
                >
                  <span className="font-medium text-secondary-900 dark:text-white">
                    {integration.name}
                  </span>
                  <span
                    className={`rounded-full px-2 py-1 text-xs font-medium ${
                      integration.status === 'connected'
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                        : 'bg-secondary-100 text-secondary-600 dark:bg-secondary-800 dark:text-secondary-400'
                    }`}
                  >
                    {integration.status === 'connected' ? 'Connecté' : 'Non connecté'}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div>
          <div className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900">
            <h3 className="font-semibold text-secondary-900 dark:text-white">Plan</h3>
            <div className="mt-4">
              <div className="text-3xl font-bold text-primary-600">Pro</div>
              <p className="mt-2 text-sm text-secondary-500">
                Accès complet à toutes les fonctionnalités
              </p>
              <div className="mt-4 space-y-2 text-sm text-secondary-600 dark:text-secondary-400">
                <p>✓ Applications illimitées</p>
                <p>✓ Workflows illimitées</p>
                <p>✓ 100 utilisateurs</p>
                <p>✓ Support prioritaire</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
